import { createSlice } from "@reduxjs/toolkit";

const complaintDetailsToSendSlice = createSlice({
  name: "complaintDetailsToSendSlice",
  initialState: {
        bbps : null
  },
  reducers: {
    setComplaintDetailsToSend: (state, action) => {
        state.bbps = action.payload;
    },
  },
});

export const { setComplaintDetailsToSend } = complaintDetailsToSendSlice.actions;

export default complaintDetailsToSendSlice.reducer;